import courseWrapper from 'cccisd-laravel-assignment/dist/components/navigations/courseWrapper';
import withModules from '../../components/withModules';
const navigations = [courseWrapper, withModules];

export default navigations;
